import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/Alert";
import { Link } from "react-router-dom";
import { loadAccounts } from "../../redux/actions/tally";
import ServerPaginationTable from "../../components/ServerPaginationTable";
import SyncStatus from "../../components/SyncStatus";
import {
  migrateTallyInvoicesData,
  migrateInvoicesToTally,
} from "../../api/index";
import SyncRemarkRender from "../../components/SyncRemarkRender";
import { loadInvoicesVoucher } from "../../redux/actions/tally";

const columns = [
  {
    Header: "Voucher ID",
    accessor: "cartInvoiceId",
  },
  {
    Header: "Voucher Date",
    accessor: "invoiceDate",
  },
  {
    Header: "Customer Name",
    accessor: "customerName",
  },
  {
    Header: "Deskera ID",
    accessor: "deskeraId",
  },
  {
    Header: "Deskera Sequence Code",
    accessor: "deskeraDocumentCode",
  },
  {
    Header: "Sync Status",
    accessor: "syncStatus",
    Cell: ({ cell: { row } }) => {
      return (
        <SyncStatus
          status={row.original.syncStatus}
          reason={row.original.reason}
          id={row.original.cartProductId}
        />
      );
    },
  },
  {
    Header: "Sync Remarks",
    accessor: "reason",
    disableSortBy: true,
    Cell: ({ cell: { row } }) => {
      let value =
        row.original?.syncStatus !== "SUCCESSFUL" && row.original?.reason
          ? row.original?.reason
          : "";
      return <SyncRemarkRender value={value} id={row.original.id.toString()} />;
    },
  },
];

function Invoices() {
  const invoicesData = useSelector((state) => {
    return state.tally.invoices;
  });
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const tallyConfig = useSelector((state) => state.tally.accounts);

  useEffect(() => {
    dispatch(loadAccounts());
    dispatch(loadInvoicesVoucher());
  }, []);

  const data = useMemo(() => invoicesData.data, [invoicesData]);

  useEffect(() => {
    setLoading(false);
    if (invoicesData && invoicesData?.data?.totalPages) {
      setPageCount(invoicesData?.data?.totalPages);
    }
  }, [invoicesData]);

  const refreshData = ({
    pageSize,
    pageIndex,
    status,
    sortBy,
    search,
    startDate,
    endDate,
  }) => {
    setLoading(true);
    dispatch(
      loadInvoicesVoucher(
        pageSize,
        pageIndex,
        status,
        sortBy,
        search ?? "",
        startDate,
        endDate
      )
    );
  };

  return (
    <>
      <div className='p-4'>
        <h3 className='mb-3'>Invoices</h3>
        {!tallyConfig.data ||
          (!tallyConfig.data.syncEnable && (
            <Alert type='warning'>
              Your synced Invoices will appear here. Please complete{" "}
              <Link to='/app/tally' className='text-alert-warning'>
                <u>Setup</u>
              </Link>{" "}
              before continuing.
            </Alert>
          ))}
        <ServerPaginationTable
          data={data?.content ? data.content : []}
          columns={columns}
          migrate={migrateTallyInvoicesData}
          syncToTally={migrateInvoicesToTally}
          cart='tally'
          refresh={refreshData}
          tab='Invoices'
          pageCount={pageCount}
          loading={loading}
          rowId='id'
        />
      </div>
    </>
  );
}

export default Invoices;
